"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var setTurnedOn_1 = __importDefault(require("./setTurnedOn"));
var setTurnedOff_1 = __importDefault(require("./setTurnedOff"));
var point_1 = require("../../selectors/point");
var global_1 = require("../../selectors/global");
function checkIsEnabledState(onStartUp) {
    if (onStartUp === void 0) { onStartUp = false; }
    var action = function (dispatch, getState) {
        var state = getState();
        var isEnabled = (0, point_1.selectPointIsEnabled)(state);
        var turnedOn = (0, global_1.selectTurnedOn)(state);
        if (isEnabled && !turnedOn) {
            dispatch((0, setTurnedOn_1.default)());
        }
        if (!isEnabled && isEnabled !== undefined && (turnedOn || onStartUp)) {
            dispatch((0, setTurnedOff_1.default)());
        }
    };
    action.type = checkIsEnabledState.type;
    return action;
}
checkIsEnabledState.type = "checkIsEnabledState";
exports.default = checkIsEnabledState;
//# sourceMappingURL=checkIsEnabledState.js.map